<template>
  <div class="footer" cpid="1133606" id="smv_Area3"
       style="width: 100%; height: 46px; position: relative; margin: 50px 0 0 0;background: #979797">
    <div id="smv_tem_11_2" ctype="banner" class="esmartMargin smartAbs " cpid="1133606" cstyle="Style1"
         ccolor="Item0" areaId="Area3" isContainer="True" pvid="" tareaId="Area3" re-direction="y" daxis="Y"
         isdeletable="True" style="height: 33px; width: 100%; left: 0px; top: 3px;z-index:2;">
      <div class="yibuFrameContent tem_11_2  banner_Style1  " style="overflow:visible;;">
        <div class="fullcolumn-inner smAreaC" id="smc_Area0" cid="tem_11_2" style="width:1000px">
        </div>
        <div id="bannerWrap_tem_11_2" class="fullcolumn-outer"
             style="position: absolute; top: 0; bottom: 0;">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "Footer"
}
</script>

<style scoped>

</style>